// extracted by mini-css-extract-plugin
module.exports = {"brush":"styles_brush__3NTPR","selection":"styles_selection__3nBSB","chartAxis":"styles_chartAxis__Rjdwf","bottomTicks":"styles_bottomTicks__2Ntf1"};